import imageImg from "../../../../../picture/slika.png";
import wordImg from "../../../../../picture/word.png";
import pdfImg from "../../../../../picture/pdf.png";
import scanImg from "../../../../../picture/scan.png";
import uploadImg from "../../../../../picture/UploadDocument.png";
import downloadImg from "../../../../../picture/DownloadFile.png";
import visibleImg from "../../../../../picture/Visible.png";
import forwardImg from "../../../../../picture/forward.png";
import letterAImg from "../../../../../picture/letterA.png";
import { useRef, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import ConfirmationModal from "../../../FolderDocument/ConfirmationModal";
import axios from "axios";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  smallCell: {
    width: "40px",
    textAlign: "center",
    cursor: "pointer"
  },
  icon: {
    width: "30px",
    height: "30px"
  }
};

function VazecaTabela({
  dokumenta,
  setDokumenta,
  moveToArhivirani,
  checkedRows,
  setCheckedRows,
  isCheckedAll,
  setIsCheckedAll
}) {
  const [selectedField, setSelectedField] = useState({
    documentId: "",
    documentType: ""
  });
  const [editData, setEditData] = useState({
    documentId: "",
    documentType: ""
  });
  const [isOpenEditConfirm, setIsOpenEditConfirm] = useState(false);
  const [fileNewDocument, setFileNewDocument] = useState(null);

  const fileInputRef = useRef();

  const { dictionary, loggedUser, apiKey, baseUrl } = useGlobalContext();

  const fileBaseUrl = baseUrl.replace("/api", "");

  const handleSelectDocument = (documentId, documentType) => {
    setSelectedField((prev) =>
      prev.documentId === documentId && prev.documentType === documentType
        ? { documentId: "", documentType: "" }
        : { documentId, documentType }
    );
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };

  const handleCheckAll = () => {
    if (isCheckedAll) {
      setCheckedRows([]);
    } else {
      setCheckedRows(dokumenta.map((z) => z.id));
    }
    setIsCheckedAll((prev) => !prev);
  };

  const handleClickUpload = (id) => {
    if (id === selectedField.documentId && selectedField.documentType) {
      setEditData(selectedField);
    } else {
      setEditData({ documentId: id, documentType: "" });
    }
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setEditData({ documentId: "", documentType: "" });
      return;
    }
    setFileNewDocument(file);
    setIsOpenEditConfirm(true);
  };

  const handleConfirmEdit = async () => {
    const formData = new FormData();
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);
    formData.append("id", editData.documentId);
    formData.append("tip_fajla", editData.documentType || "");
    formData.append("file", fileNewDocument);

    try {
      const { data } = await axios.post(
        `${baseUrl}/prva_pomoc/upload.php`,
        formData
      );

      if (data.status === 200) {
        // Azuriraj boju i putanju u lokalnom stanju
        setDokumenta((prev) =>
          prev.map((dok) =>
            dok.id !== editData.documentId
              ? dok
              : {
                  ...dok,
                  [data.column]: "green",
                  [`${data.column}Path`]: data.path
                }
          )
        );
      } else {
        alert(data.message || "Greška pri uploadu fajla.");
      }
    } catch (e) {
      console.error("Greška pri uploadu:", e);
      alert("Došlo je do greške prilikom povezivanja sa serverom.");
    }

    cancelEditConfirm();
  };

  const cancelEditConfirm = () => {
    setEditData({ documentId: "", documentType: "" });
    setIsOpenEditConfirm(false);
    setFileNewDocument(null);
  };

  // View — otvori fajl u novom tabu
  const handleView = (dokument) => {
    const path = getSelectedPath(dokument);
    if (!path) return;
    window.open(`${fileBaseUrl}/${path}`, "_blank");
  };

  // Download — otvori fajl u novom tabu
  const handleDownload = (dokument) => {
    const path = getSelectedPath(dokument);
    if (!path) return;
    window.open(`${fileBaseUrl}/${path}`, "_blank");
  };

  // Vraca putanju selektovanog fajla, ili prvog dostupnog
  const getSelectedPath = (dokument) => {
    if (
      selectedField.documentId === dokument.id &&
      selectedField.documentType
    ) {
      return dokument[`${selectedField.documentType}Path`] || "";
    }
    // Ako nista nije selektovano, uzmi prvi dostupni fajl
    for (const tip of ["word", "pdf", "image", "scan"]) {
      if (dokument[`${tip}Path`]) return dokument[`${tip}Path`];
    }
    return "";
  };

  return (
    <>
      <table style={{ width: "100%" }}>
        <tr>
          <th style={styles.smallCell}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={styles.smallCell}>
            <img src={wordImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={pdfImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={imageImg} style={{ width: "30px" }} />
          </th>
          <th style={styles.smallCell}>
            <img src={scanImg} style={{ width: "30px" }} />
          </th>
          <th style={{ fontSize: "1.7em", ...styles.cell }}>{dictionary["vazecaDokumenta"]}</th>
          <th style={{ fontSize: "1.7em", ...styles.cell }}>{dictionary["dodato"]}</th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
        </tr>
        {dokumenta.map((dokument) => (
          <tr key={dokument.id}>
            <td style={styles.cell}>
              <input
                type="checkbox"
                checked={checkedRows.includes(dokument.id)}
                onChange={() => handleCheckRow(dokument.id)}
                style={{ width: "30px" }}
              />
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "word")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "word"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.word,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "pdf")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "pdf"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.pdf,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "image")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "image"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.image,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handleSelectDocument(dokument.id, "scan")}
              style={{
                ...styles.smallCell,
                border:
                  selectedField.documentId === dokument.id &&
                  selectedField.documentType === "scan"
                    ? "2px solid black"
                    : ""
              }}
            >
              <div
                style={{
                  backgroundColor: dokument.scan,
                  width: "25px",
                  height: "25px",
                  margin: "auto"
                }}
              ></div>
            </td>
            <td style={{ textAlign: "start", fontWeight: "bold", fontSize: "1.5em", padding: "5px" }}>{dokument.nazivDokumenta}</td>
            <td style={{ fontWeight: "bold", fontSize: "1.5em", ...styles.cell }}>{dokument.datum}</td>
            <td
              onClick={() => handleView(dokument)}
              style={styles.smallCell}
            >
              <img src={visibleImg} style={{ width: "30px" }} />
            </td>
            <td style={styles.smallCell}>
              <img src={forwardImg} style={{ width: "30px" }} />
            </td>
            <td
              onClick={() => handleDownload(dokument)}
              style={styles.smallCell}
            >
              <img src={downloadImg} style={{ width: "25px" }} />
            </td>
            <td
              onClick={() => handleClickUpload(dokument.id)}
              style={styles.smallCell}
            >
              <img src={uploadImg} style={{ width: "25px" }} />
            </td>
            <td
              onClick={() => moveToArhivirani(dokument)}
              style={styles.smallCell}
            >
              <img src={letterAImg} style={{ width: "20px" }} />
            </td>
          </tr>
        ))}
      </table>

      <input
        type="file"
        accept="image/*, .pdf, .docx"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />

      {isOpenEditConfirm && (
        <ConfirmationModal
          text={`${
            dictionary[
              editData.documentType === "scan"
                ? "confirmAddDocumentScan"
                : editData.documentType === "image"
                  ? "confirmAddDocumentImage"
                  : "confirmAddDocument"
            ]
          } ${dictionary["warningDeleteOld"]}`}
          handleConfirm={handleConfirmEdit}
          handleCancel={cancelEditConfirm}
        />
      )}
    </>
  );
}

export default VazecaTabela;